import type { Cashier } from "./cashier"
import { api } from "@/api"

export const retrieveCashier = async (
  cashierId: string
): Promise<Cashier> => {
  const response = await api.get<Cashier>(
    `/cashiers/${cashierId}`
  )
  return response.body
}
